import { Tag } from 'antd'

import Box from '~/core/Box'

import ThreeDTag from './ThreeDTag'

export const TAG_STYLE = { marginRight: '8px', height: 'fit-content' }

interface TabLabelPropsType {
    hasGenerated2dDfmFailed?: boolean
    is2dDfmGenerating?: boolean
    is3dDfmSlide?: boolean
    isPublished?: boolean
    isUnsaved?: boolean
}

const TagLabel = (props: TabLabelPropsType) => {
    const {
        hasGenerated2dDfmFailed,
        is2dDfmGenerating,
        is3dDfmSlide,
        isPublished,
        isUnsaved,
    } = props

    let StatusTag

    if (!isPublished) {
        StatusTag = () => <Tag style={TAG_STYLE}>Pending release</Tag>
    }
    if (isUnsaved) {
        StatusTag = () => (
            <Tag color="red" style={TAG_STYLE}>
                Unsaved
            </Tag>
        )
    }
    if (is2dDfmGenerating) {
        StatusTag = () => <Tag style={TAG_STYLE}>Generating 2D DFM</Tag>
    }
    if (hasGenerated2dDfmFailed) {
        StatusTag = () => (
            <Tag color="red" style={TAG_STYLE}>
                Error
            </Tag>
        )
    }

    const show3dTag = isUnsaved || is3dDfmSlide

    return (
        <Box justifyContent="end">
            {show3dTag && <ThreeDTag />}
            {StatusTag && <StatusTag />}
        </Box>
    )
}

export default TagLabel
